import React from "react";
import { useLocation } from "react-router-dom";
import LegacyAccountPage from "./AccountPage";
import V2AccountPage from "./AccountPage.jsx";
import { isSettingsV2Path } from "../../universal/v2Routes";

export default function AccountPageByRoute(props) {
    const location = useLocation();
    const AccountPageComponent = isSettingsV2Path(location.pathname)
        ? V2AccountPage
        : LegacyAccountPage;

    return <AccountPageComponent {...props} />;
}
